export default __webpack_public_path__ + "c44adf44a21d8ab1ed1e9212e92449c0.png";